// extracted by mini-css-extract-plugin
export default {"dialogTitle":"DisplayCandidateApplication_dialogTitle__Fe6iQ"};